namespace GeniuzPOS.Administration {
    export class CsVatCodeColumns {
        static columnsKey = 'Administration.CsVatCode';
    }
}
